import Highcharts from 'highcharts/es-modules/masters/highstock.src.js';
import _ from 'lodash';
import { getXAxisColumns, isDescendingSort, isTimeSeries, isXAxisOrdinalBased, } from '../core/chart-model-utils';
import { getEffectiveBarWidthForNonResponsiveLayout, isXAxisVertical, } from '../core/chart-type-specification-service';
export function getScrollEnabledMinMaxConfig(series, chartType, containerWidth, containerHeight, chartModel) {
    const highchartsOptions = Highcharts.getOptions();
    const axisLabelFontSize = highchartsOptions.xAxis.labels.style.fontSize !== 'inherit'
        ? highchartsOptions.xAxis.labels.style.fontSize
        : '12px';
    let sanitizedFontSize = axisLabelFontSize.match(/^(\d{1,2})px$/);
    sanitizedFontSize = +sanitizedFontSize[1];
    let minExtreme = null;
    let maxExtreme = null;
    let pointsOnScrollAxis = null;
    series.forEach(serie => {
        const data = serie.data;
        if (data.length > 0) {
            minExtreme =
                minExtreme !== null
                    ? Math.min(minExtreme, _.minBy(data, 'x').x)
                    : _.minBy(data, 'x').x;
            maxExtreme =
                maxExtreme != null
                    ? Math.max(maxExtreme, _.maxBy(data, 'x').x)
                    : _.maxBy(data, 'x').x;
        }
    });
    const effectiveBarWidth = getEffectiveBarWidthForNonResponsiveLayout(chartType, series, sanitizedFontSize);
    if (isXAxisVertical(chartType)) {
        pointsOnScrollAxis = Math.floor(containerHeight / effectiveBarWidth);
    }
    else {
        pointsOnScrollAxis = Math.floor(containerWidth / effectiveBarWidth);
    }
    let isReversed = false;
    const xAxisColumns = getXAxisColumns(chartModel);
    if (isTimeSeries(chartModel) && !isXAxisOrdinalBased(chartModel)) {
        isReversed = xAxisColumns.some(xAxisColumn => isDescendingSort(chartModel, xAxisColumn));
    }
    if (series.length) {
        const pointRange = _.head(series).pointRange || 1;
        if (isReversed) {
            minExtreme = Math.max(minExtreme, maxExtreme - pointsOnScrollAxis * pointRange);
        }
        else {
            maxExtreme = Math.min(maxExtreme, minExtreme + pointsOnScrollAxis * pointRange);
        }
    }
    return {
        min: minExtreme,
        max: maxExtreme,
    };
}
//# sourceMappingURL=highchart-config.util.js.map